import { FunctionComponent, useEffect } from 'react';

import { AreaChart } from 'PDF/components/Charts/AreaChart/AreaChart';
import { IAreaChartData } from 'PDF/components/Charts/AreaChart/types';
import { useGenerateImageFromCharts } from 'PDF/hooks/useGenerateImageFromCharts';

interface IChartWithBarsWrapper {
  info: IAreaChartData;
  aspectRatio?: number;
  updateState: (title: string, src: string) => void;
  stacked?: boolean;
  showDataLabels?: boolean;
  axiosInPercentageProps?: {
    min: number;
    max: number;
    stepSize: number;
  };
}

export const AreaChartWrapper = ({
  aspectRatio = 2.5,
  info,
  updateState,
  stacked,
  showDataLabels,
}: IChartWithBarsWrapper) => {
  const [chartPortal, chartImgSrc] = useGenerateImageFromCharts(AreaChart as FunctionComponent, {
    aspectRatio,
    info,
    stacked,
    showDataLabels,
  });

  useEffect(() => {
    if (chartImgSrc) {
      updateState(info.title, chartImgSrc);
    }
  }, [chartImgSrc]);

  return <>{chartPortal}</>;
};
